@for (button of buttons; track button) {
  <button
    type="button"
    color="primary"
    matFab
    class="!h-12 !w-12 text-[20px] leading-[20px] blue-theme-bg-1 z-[100] round-btn"
    (click)="onButtonClick(button.id, button.action)"
    [attr.aria-label]="button.aria"
    [matTooltip]="button.tooltip"
  >
    <mat-icon color="primary" class="text-white">{{ button.image }}</mat-icon>
  </button>
}
